var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96739 11.8426C4.03712 11.9129 4.12007 11.9687 4.21146 12.0068C4.30285 12.0449 4.40088 12.0645 4.49989 12.0645C4.5989 12.0645 4.69693 12.0449 4.78833 12.0068C4.87972 11.9687 4.96267 11.9129 5.03239 11.8426L8.46739 8.4076C8.53712 8.33731 8.62007 8.28151 8.71146 8.24344C8.80286 8.20536 8.90088 8.18576 8.99989 8.18576C9.0989 8.18576 9.19693 8.20536 9.28833 8.24344C9.37972 8.28151 9.46267 8.33731 9.53239 8.4076L12.9674 11.8426C13.0371 11.9129 13.1201 11.9687 13.2115 12.0068C13.3029 12.0448 13.4009 12.0645 13.4999 12.0645C13.5989 12.0645 13.6969 12.0448 13.7883 12.0068C13.8797 11.9687 13.9627 11.9129 14.0324 11.8426C14.1721 11.7021 14.2505 11.512 14.2505 11.3139C14.2505 11.1157 14.1721 10.9256 14.0324 10.7851L10.5899 7.3426C10.168 6.92125 9.59615 6.68458 8.99989 6.68458C8.40364 6.68458 7.83177 6.92125 7.40989 7.3426L3.96739 10.7851C3.82771 10.9256 3.7493 11.1157 3.7493 11.3139C3.7493 11.512 3.82771 11.7021 3.96739 11.8426Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.67538ecc6e0999b5ec6d3cfe56d4ab3b.svg";
export { ForwardRef as ReactComponent };